import 'firebase/compat/firestore';
import moment from 'moment';
import {FieldValue, Timestamp} from 'firebase/firestore';



;


/**
 * Utiliy function to convert a firebase datetime type to a js date
 * @param input a value that can be either Timestamp or FiledValue
 */
export function firestoreDateToJsDate(input: Timestamp | FieldValue | Date | moment.Moment | string): Date {
    if (input instanceof Timestamp) {
        return input.toDate();
    } else if (input instanceof FieldValue) {
        throw new Error(`Filed Value cannot be converted to date`);
    } else if (input instanceof Date) {
        return input;
    } else if (moment.isMoment(input)) { // Workaround sometimes the use can pass moment obj...
        return (input as moment.Moment).toDate();
    } else if (typeof input === 'string') { // Workaround sometimes the use can pass a string (sob) obj...
        return moment((input as string)).toDate();
    } else if ((input as any).seconds !== undefined && (input as any).nanoseconds !== undefined) {
        return new Timestamp((input as any).seconds, (input as any).nanoseconds).toDate();
    } else if ((input as any)._seconds) { // Workaround sometimes you just have an obj like { _seconds: xxx, _milliseconds: xxxx }
        return new Date((input as any)._seconds * 1000);
    } else {
        throw new Error(`Cannot convert ${typeof input} to date`);
    }
}